/**
 * Language Dropdown — 헤더 언어 선택 드롭다운 (한국어/영어)
 */
export class LanguageDropdown {
    constructor(buttonId, dropdownId) {
        this.button = document.getElementById(buttonId);
        this.dropdown = document.getElementById(dropdownId);
        this.isOpen = false;

        if (!this.button || !this.dropdown) return;

        this.init();
    }

    init() {
        this.button.addEventListener("click", (e) => {
            e.stopPropagation();
            this.toggle();
        });

        this.handleOutsideClick = (e) => {
            if (
                !this.button.contains(e.target) &&
                !this.dropdown.contains(e.target)
            ) {
                this.close();
            }
        };
        document.addEventListener("click", this.handleOutsideClick);

        this.handleEscape = (e) => {
            if (e.key === "Escape" && this.isOpen) {
                this.close();
            }
        };
        document.addEventListener("keydown", this.handleEscape);

        const links = this.dropdown.querySelectorAll("a");
        links.forEach((link) => {
            link.addEventListener("click", () => this.close());
        });
    }

    toggle() {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    open() {
        this.isOpen = true;
        this.dropdown.classList.add("is-open");
        this.button.setAttribute("aria-expanded", "true");
    }

    close() {
        this.isOpen = false;
        this.dropdown.classList.remove("is-open");
        this.button.setAttribute("aria-expanded", "false");
    }
}
